<div class="container">
  <div *ngIf="closable" class="icon-close" (click)="closeJob()">
    <span class="fa fa-times"></span>
  </div>

  <div class="job-status-icon">
    <div class="icon-container" *ngIf="showProgress">
      <svg class="progress-ring" viewBox="0 0 50 50">
        <circle
          class="progress-ring-circle-bg"
          cx="25"
          cy="25"
          r="22"
          fill="none"
          stroke-width="2"
        ></circle>
        <circle
          class="progress-ring-circle"
          [class.progress-complete]="isProgressComplete"
          cx="25"
          cy="25"
          r="22"
          fill="none"
          stroke-width="2"
          [attr.stroke-dasharray]="138.23"
          [attr.stroke-dashoffset]="isProgressComplete ? 0 : (138.23 - (138.23 * progressPercentage / 100))"
          transform="rotate(-90 25 25)"
        ></circle>
      </svg>
      <span class="fa fa-arrow-circle-up icon-status-in-progress"></span>
    </div>
    <span *ngIf="job?.inProgress && !showProgress" class="fa fa-arrow-circle-up icon-status-in-progress"></span>
    <span *ngIf="job?.succeed && !showProgress" class="fa fa-check-circle icon-status-finish"></span>
    <span *ngIf="job?.completedWithErrors && !job?.canceled" class="fa fa-exclamation-circle icon-status-warning"></span>
    <span *ngIf="job?.canceled" class="fa fa-exclamation-triangle icon-status-cancel"></span>
    <span *ngIf="job?.canceling" class="ti-icon-dots-spinner"></span>
  </div>

  <div class="job-process-info">
    <h5 class="job-process-name">{{ jobProcessName }}</h5>

    <div class="job-status-details" *ngIf="job?.completed">
      <span class="completion-status" *ngIf="completionStatus">{{ completionStatus }}</span>
      <span class="completion-details" *ngIf="completionDetails">{{ completionDetails }}</span>
      <div class="job-process-monitor" *ngIf="!completionStatus && message">
        <div>{{ message }}</div>
      </div>
    </div>

    <div class="job-process-monitor" *ngIf="job?.inProgress">
      <div class="job-process-container" *ngIf="job?.progress">
        <span *ngIf="job.progress.action" class="label">{{ job?.status }}...</span>
      </div>
      <div *ngIf="message && !job?.progress" class="label">{{ message }}</div>
    </div>

    <div *ngIf="job?.roomName" class="job-room-info">
      <span class="room-label">{{miscStrings.room}}</span>
      <span class="job-room-name">{{job.roomName}}</span>
    </div>

    <button *ngIf="job && !job.completed && cancelable" (click)="cancelJob()" kendoButton fillMode="solid" themeColor="tertiary">{{ miscStrings.cancel }}</button>
    <button *ngIf="showGetJobResultButton" (click)="showJobResult()" kendoButton [primary]="true">
      <span class="fa fa-cloud-download"></span>
      {{ strings.getJobResult }}
    </button>
  </div>
</div>
